import { Container, Typography, Box, Grid, Card, Paper } from "@mui/material";
import { motion,  } from "framer-motion";
import Divider from "@mui/material/Divider";
import hotel from '../../assets/hotel.jpg';
import flight from '../../assets/flight.jpg';
import accommodation from '../../assets/Accommodation.jpg';
import car from '../../assets/car.jpg';
import guide from '../../assets/guide.jpg';
import sea  from '../../assets/sea.jpg';
import { useTranslation } from 'react-i18next';
const Services = () => {
const { t } = useTranslation();
  const services = [
    {
      title: "Flight Reservation",
      description:
        "Skip the hassle of booking flight. Just tell us where you want to Go and we can settle the rest!​",
      images: [`${flight}`],
    },
    {
      title: "Hotel Reservation",
      description:
        "We put out clients comfort first Whenever we book for Accommodation.​",
      images: [`${hotel}`],
    },
    {
      title: "On-Ground Arrangement",
      description:
        "Our experienced and dedicated staff, having a daily contact with hoteliers & self-catered accommodation owners-managers can provide you tailor-made solutions to even the most complicated Accommodation needs. ",
      images: [`${accommodation}`],
    },
    {
      title: "Tourist Guide",
      description:
        "Being in foreign land can be terrifying, Especially when the local cannot speak English or Arabic! If you travel with us, Well trained tour guides can make your Vacation a lot easier! ",
      images: [`${guide}`],
    },
    {
      title: "Personalize Itinerary",
      description:
        "Vacation are meant to be enjoy at your own time and pace. Skip all Those morning role calls. Plan your Own itinerary. If you don’t know to Start, we do!",
      images: [`${sea}`],
    },
    {
      title: "Private Transportation",
      description:
        "It is such a hassle to ride on a tour bus, Especially when you are travelling with Your little ones. Don’t worry, we got you Covered. Your own private transportation awaits when you travel with us​",
      images: [`${car}`],
    },
    
  ];

  return (
    <Container>
      <Box
        id="services"
        sx={{
          minHeight: "120vh",
          display: "flex",
          flexDirection: "column",
          justifyContent: "start",
          alignItems: "center",
          textAlign: "center",
          position: "relative",
          py: 4,
        }}
      >
        <motion.div
          initial={{ opacity: 0, y: 20 }}
          animate={{ opacity: 1, y: 0 }}
          transition={{ duration: 0.8 }}
        >
          <Box
            sx={{
              position: "relative",
              textAlign: "center",
              mb: 8,
            }}
          >
            <Typography
              variant="h2"
              component="div"
              sx={{
                color: "#000000",
                fontWeight: 700,
                fontSize: { xs: "2rem", md: "2.5rem" },
                position: "relative",
                fontFamily: "Montserrat",
              }}
            >
              {t('Titles.services')}
            </Typography>
            <Box
              sx={{
                display: "flex",
                justifyContent: "center",
                width: "100%",
                paddingTop: "20px",
              }}
            >
              <Divider
                sx={{
                  backgroundColor: "primary.main",
                  width: "10vh",
                  height: "2px",
                }}
              />
            </Box>
          </Box>
        </motion.div>
        <Grid container spacing={4}>
          {services.map((project, index) => (
            <Grid
            item xs={12} sm={12} md={6} key={index} sx={{ display: 'flex', justifyContent: 'center', alignItems: 'center', flexDirection: 'column' }}
            >
              
                <Card
                  sx={{
                    height: "15.625rem",
                    maxWidth: "22.5rem",
                    backgroundColor: "rgba(0, 188, 212, 0.1)",
                    border: "2px solid #327d81",
                    borderRadius: "16px",
                    boxShadow: "0 0 30px rgba(50, 125, 129, 0.8)",
                    transition: "all 0.3s ease",
                    "&:hover": {
                      transform: "translateY(-10px)",
                      boxShadow: "0 0 20px rgba(50, 125, 129, 0.8)",
                      backgroundColor: "rgba(50, 125, 129, 0.15)",
                    },
                  }}
                >
                  {project.images.map((image, index) => (
                    <Paper
                      key={index}
                      elevation={0}
                      sx={{
                    height: "15.625rem",
                        display: "flex",
                        alignItems: "center",
                        justifyContent: "center",
                        backgroundColor :'transparent',
                        position: "relative",
                        p: 0,
                      }}
                    >
                      <Box
                        component="img"
                        src={image}
                        alt={`${project.title}`}
                        sx={{
                          width: "100%",
                          height: "100%",
                          objectFit: "cover",
                        }}
                        onError={(e) => {
                          console.error(`Failed to load image: ${image}`);
                          e.target.src = "/logo192.png";
                        }}
                      />
                    </Paper>
                  ))}
                </Card>
                <Typography
                  component="div"
                  sx={{
                    fontSize: "1.3rem",
                    paddingTop: 2,
                    textAlign: "center",
                    fontFamily: "Montserrat",
                    color: "#000000",
                    fontWeight: 600,
                  }}
                >
                  {t(`${project.title}.title`)}
                </Typography>
                <Typography
                  sx={{
                    fontSize: "1rem",
                    letterSpacing: "0.50px",
                    lineHeight: 1.6,
                    paddingTop: 2,
                    textAlign: "center",
                    color: "#5a5c61",
                    fontFamily: "Noto Sans",
                  }}
                >
                  {t(`${project.title}.description`)}
                </Typography>
            </Grid>
          ))}
        </Grid>
      </Box>
    </Container>
  );
};

export default Services;
